import { z } from 'zod';
import { PaginationSchema } from './common.schema';

export const TransactionUserSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const TransactionCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  emoji: z.string(),
  pinned: z.boolean().nullable().optional(),
});

export const TransactionSchema = z.object({
  id: z.string(),
  type: z.enum(['expense', 'settlement', 'pool_event']),
  event_type: z.enum(['insert', 'funded_expense']).optional(),
  description: z.string().nullable().optional(),
  amount: z.number(),
  displayAmount: z.number().optional(),
  currency: z.string(),
  date: z.string(),
  paid_by: z.string().optional(),
  created_by: z.string().optional(),
  kind: z.enum(['manual', 'pool_insert_adjustment', 'pool_expense_adjustment']).optional(),
  origin_event_id: z.string().nullable().optional(),
  pool_id: z.string().optional(),
  pool_name: z.string().optional(),
  expense_id: z.string().nullable().optional(),
  user: TransactionUserSchema.optional(),
  to_user: TransactionUserSchema.optional(),
  from_user: TransactionUserSchema.optional(),
  category: TransactionCategorySchema.optional(),
});

export const TransactionsResponseSchema = z.object({
  transactions: z.array(TransactionSchema),
  pagination: PaginationSchema.optional(),
});

export type Transaction = z.infer<typeof TransactionSchema>;
export type TransactionsResponse = z.infer<typeof TransactionsResponseSchema>;
